import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { VH_RESOURCE } from '../types/resourceData.js';
export const vhResourcesDescriptor = {
    name: VH_RESOURCE,
    label: 'VH Resource',
    domain: 'vectorhub',
    collectionPath: 'org/{orgId}/vh_resources',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Org-level resource (query template or direct data). Written by VH console.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'resourceId',
            label: 'Resource ID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: '== doc id.',
        },
        {
            name: 'type',
            label: 'Type',
            type: 'enum',
            required: true,
            enumValues: ['query', 'template'],
        },
        {
            name: 'data',
            label: 'Data',
            type: 'string',
            required: true,
            maxLength: 16000,
            description: 'SQL string, template body, or QueryDefinition JSON. Object values stored as JSON string.',
        },
        {
            name: 'description',
            label: 'Description',
            type: 'string',
            required: false,
            maxLength: 500,
        },
        {
            name: 'paramOrder',
            label: 'Parameter Order',
            type: 'array',
            required: false,
            arrayItemType: 'string',
            description: 'Ordered parameter names. Each name max 80 chars.',
        },
        {
            name: 'params',
            label: 'Parameters',
            type: 'object',
            required: false,
            description: 'Parameter definitions keyed by name.',
        },
        {
            name: 'columns',
            label: 'Filterable Columns',
            type: 'object',
            required: false,
            description: 'Filterable columns (whitelist) for the data module filter. Only for type=query. Array of { name, type }.',
        },
        {
            name: 'orderBy',
            label: 'Order By',
            type: 'string',
            required: false,
            maxLength: 80,
            description: 'Default ORDER BY alias for filtered query wraps. Prefer a stable unique column (e.g. id).',
        },
        {
            name: 'targetAgentId',
            label: 'Target Agent ID',
            type: 'string',
            required: false,
            maxLength: 128,
            description: "Specific agent or '*' for any agent in org.",
        },
        {
            name: 'updatedAt',
            label: 'Updated At',
            type: 'string',
            required: true,
            maxLength: 32,
        },
        {
            name: 'updatedBy',
            label: 'Updated By',
            type: 'string',
            required: true,
            maxLength: 128,
        },
    ],
};
//# sourceMappingURL=vhResources.descriptor.js.map